import { z } from "zod";

export const REQUIRED_TYPES = ["lossRuns", "mvr"];

const DocumentSchema = z.object({
  type: z.enum(["lossRuns", "mvr"], { required_error: "Document type is required" }),
  url: z.string().min(1, "Document URL required"),
  name: z.string().optional(),
  id: z.union([z.string(), z.number()]).optional(),
});

export const Step10Schema = z.object({
  documents: z.array(DocumentSchema).default([]),
});
